/** DE translations for Les Aiguilles Blanches */
const de: Record<string, string> = {
  subtitle: "Pistenraupen-Simulation",
  startGame: "Spiel starten",
  resumeGame: "Fortsetzen",
  newGame: "Neues Spiel",
  // UNUSED continue: "Fortfahren",
  settings: "Einstellungen",
  controls: "Steuerung",
  changelog: "Neuigkeiten",
  howToPlay: "Anleitung",
  howToPlayMove: "{keys} oder Pfeiltasten bewegen",
  howToPlayMoveHybrid: "{keys}/Pfeile oder Touch-D-pad",
  howToPlayGroom: "{groomKey} zum Präparieren",
  howToPlayGroomHybrid: "{groomKey} oder Präparier-Taste halten",
  fullscreen: "Vollbild",
  fullscreenHint: "F drücken für Vollbild",
  exitFullscreen: "Vollbild beenden",
  back: "Zurück",
  backToGame: "Zurück zum Spiel",
  // UNUSED loading: "Laden...",
  inputKeyboard: "✓ Tastatur erkannt",
  inputKeyboardOff: "✗ Keine Tastatur",
  inputTouch: "✓ Touchscreen erkannt",
  inputTouchOff: "✗ Kein Touchscreen erkannt",
  inputGamepad: "✓ Gamepad verbunden",
  inputGamepadOff: "✗ Kein Gamepad",
  updateAvailable: "Neue Version verfügbar — tippen zum Neuladen",
  madeIn: "Mit ❄️ in Savoyen gemacht",
  feedback: "Feedback geben",
  on: "✓ AN",
  off: "✗ AUS",
  zoneClosed: "🚫 ZONE GESPERRT",
  
  // Settings
  language: "Sprache",
  accessibility: "Barrierefreiheit",
  highContrast: "Hoher Kontrast",
  reducedMotion: "Weniger Bewegung",
  showFps: "FPS anzeigen",
  showDebug: "Debug-Infos",
  skiStyle: "Stil",
  skiTricks: "Tricks",
  skiBestCombo: "Beste Kombo",
  quitGame: "Spiel verlassen",
  display: "Anzeige",
  displayWindowed: "Fenster",
  displayFullscreen: "Vollbild",
  displayBorderless: "Rahmenlos",
  colorblindMode: "Farbenblind",
  none: "Keine",
  deuteranopia: "Deuteran.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Bewegen",
  moveUp: "Hoch",
  moveDown: "Runter",
  moveLeft: "Links",
  moveRight: "Rechts",
  groom: "Präparieren",
  winch: "Winde",
  pause: "Pause",
  keyboard: "Tastatur",
  clickToRebind: "Klicken zum Ändern",
  pressKey: "Taste drücken...",
  pressGamepadButton: "Gamepad-Taste drücken...",
  noGamepad: "Kein Gamepad verbunden",
  gamepadButtons: "Gamepad",
  saved: "Gespeichert!",
  resetControls: "Zurücksetzen",
  controlsReset: "Steuerung zurückgesetzt!",
  movementSensitivity: "Empfindlichkeit",
  keyboardLayout: "Tastaturlayout",
  customBindings: "Benutzerdefiniert",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Touch",
  // UNUSED touchSupported: "Touch OK",
  noGamepadConnected: "Kein Gamepad verbunden",
  gamepadDiagnostic: "Controller-Test",
  connectGamepadDiag: "Controller zum Testen verbinden",
  gamepadDiagButtons: "Tasten",
  gamepadDiagSticks: "Sticks",
  gamepadDiagTriggers: "Trigger",

  // Audio
  audio: "Audio",
  masterVolume: "Gesamtlautstärke",
  musicVolume: "Musik",
  sfxVolume: "Soundeffekte",
  engineVolume: "Motor",
  voiceVolume: "Stimme",
  ambienceVolume: "Ambiente",
  mute: "Stumm",

  backgroundAudio: "Hintergrundaudio",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Abfahrtsmodus",
  ski: "Ski",
  snowboard: "Snowboard",
  random: "Zufällig",
  skiIt: "Abfahrt!",
  rideIt: "Boarden!",
  skiAgain: "Nochmal Ski!",
  rideAgain: "Nochmal Ride!",
  skiRunSpeed: "Tempo",
  skiRunTime: "Zeit",
  skiRunGates: "Tore",
  
  // How to Play hints
  howToPlayMoveTouch: "Verwende das virtuelle D-Pad",
  howToPlayMoveGamepad: "Stick oder D-Pad zum Bewegen",
  howToPlayGroomTouch: "Präparier-Taste halten",
  howToPlayGroomGamepad: "zum Präparieren",
  howToPlayFuel: "Achte auf Kraftstoff und Ausdauer!",
  howToPlayWinch: "{winchKey} bei einem Ankerpfosten für die Winde",
  howToPlayWinchTouch: "Winden-Taste bei einem Ankerpfosten halten",
  howToPlayWinchGamepad: "bei einem Ankerpfosten für die Winde",
  howToPlayWinchHybrid: "{winchKey} oder Winden-Taste bei einem Ankerpfosten halten",
  
  // Winch
  winchSnapped: "💥 Seil gerissen!",
  winchAttached: "🔗 Winde befestigt! Halte {winchKey} für Unterstützung.",
  winchActive: "WINDE",
  // UNUSED winchHint: "Drücke {winchKey} bei einem nummerierten Ankerpfosten für die Winde",
  // UNUSED winchHintTouch: "Halte 🔗 für die Winde",
  // UNUSED accessPath: "Zufahrtsweg",
  // UNUSED toPiste: "Zur Piste",
  
  // Game
  // UNUSED paused: "Pausiert",
  resume: "Fortsetzen",
  quitToMenu: "Zum Menü",
  levelComplete: "Piste geschafft!",
  levelFailed: "Piste fehlgeschlagen",
  tryAgain: "Nochmal",
  coverage: "Abdeckung",
  time: "Zeit",
  // UNUSED target: "Ziel",
  // UNUSED rating: "Bewertung",
  nextLevel: "Nächste Piste",
  // UNUSED replay: "Wiederholen",
  // UNUSED pressContinue: "Leertaste oder tippen zum Fortfahren",
  pauseTitle: "⏸️ Pause",
  restart: "Neustart",
  skipRun: "Abfahrt überspringen",
  newRun: "Neue Piste",
  quit: "Beenden",
  menu: "Menü",
  levelSelect: "Pistenplan",
  locked: "Gesperrt",
   completeToUnlock: "Schließe {name} ab zum Freischalten",
  tutorial: "Skischule",
  timeUsed: "Benötigte Zeit",
  excellent: "Ausgezeichnet!",
  good: "Gut gemacht!",
  passed: "Geschafft",
  bonusFuel: "Kraftstoff verbraucht",
  bonusFlawless: "Erster Versuch",
  bonusSpeed: "Zeit",
  bonusWinch: "Windeneinsätze",
  bonusExplore: "Wege erkundet",
  bonusPrecision: "Präparierqualität",
  retry: "Wiederholen",
  gameComplete: "Spiel beendet!",
  viewCredits: "Credits anzeigen",
  creditsTitle: "Glückwunsch!",
  creditsSubtitle: "Du hast Les Aiguilles Blanches gemeistert",
  creditsCreatedBy: "Erstellt von",
  creditsDevelopedWith: "Entwickelt mit",
  creditsArtDirection: "Künstlerische Leitung",
  creditsRetroInspiration: "Eine Hommage an Retro-Klassiker wie SkiFree",
  creditsInspiredBy: "Inspiriert von",
  creditsGroomers: "Die Pistenpräparierer der Savoie",
  creditsDedication: "Für die Nachtschichten, die die Pisten präparieren, während wir schlafen",
  creditsThanks: "Danke fürs Spielen!",
  creditsSeeYou: "Bis bald auf der Piste!",
  creditsLine: "Komm, Kleiner. Die Sonne geht auf. Der Berg ist bereit.",
  playAgain: "Nochmal spielen",
  skipCredits: "Taste drücken zum Überspringen",
  fr: "Französisch",
  
  // Levels - Tutorial step by step
  tutorialName: "Tutorial - Erste Schritte",
  tutorialTask: "Grundlagen lernen",
  prologueLine: "4 Uhr morgens. Der Berg gehört dir. An die Arbeit.",
  prologueSkip: "Beliebige Taste drücken",
  tutorialIntro: "Willkommen in Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Tutorial wird übersprungen… Tippen zum Wiederholen.",
  skipTutorialGamepad: "⏭️ Tutorial wird übersprungen… Drücke eine Taste zum Wiederholen.",
  tutorialWelcome: "🏔️ Jean-Pierre, Chefpräparierer. Fahr über die Piste — nutze {keys} oder ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, Chefpräparierer. Fahr über die Piste — nutze das D-Pad links.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, Chefpräparierer. Fahr über die Piste — nutze den linken Stick oder das D-Pad.",
  // UNUSED     tutorialControls: "🎮 Um den Pistenbully zu bewegen, nutze {keys} oder die Pfeiltasten ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Um den Pistenbully zu bewegen, nutze das D-Pad ◀▲▼▶ links.",
  // UNUSED     tutorialControlsGamepad: "🎮 Um den Pistenbully zu bewegen, nutze den linken Stick oder das D-Pad.",
  // UNUSED     tutorialMove: "➡️ Los, probier's! Fahr über die Piste — der weiße Schnee muss präpariert werden.",
  // UNUSED     tutorialGroomIntro: "✅ Gut gemacht! Jetzt lernen wir das Präparieren.",
  tutorialGroomAction: "❄️ Halte {groomKey} beim Fahren, um den Schnee zu präparieren. Du wirst sehen, das geht wie von selbst!",
  tutorialGroomActionTouch: "❄️ Halte die Präparier-Taste rechts beim Fahren, um den Schnee zu präparieren.",
  tutorialGroomActionGamepad: "❄️ Halte {groomKey} beim Fahren, um den Schnee zu präparieren. Du wirst sehen, das geht wie von selbst!",
  tutorialGroomGoal: "📊 So geht's! Präpariere mindestens 60% vor der Öffnung. Die Skifahrer kommen!",
  // UNUSED   tutorialCoverage: "📊 Siehst du? Der Schnee wird glatter! Präpariere weiter!",
  // UNUSED   tutorialHUD: "📈 Schau oben aufs Dashboard: der rote Balken ist Kraftstoff, der grüne Ausdauer, der weiße die Abdeckung. Die Uhr läuft!",
  // UNUSED   tutorialGoal: "🎯 Du musst mindestens 60% der Piste vor der Öffnung präparieren. Die Skifahrer kommen bald!",
  // UNUSED tutorialFuel: "⛽ Vorsicht, Fahren verbraucht Kraftstoff. Bei Missionen fahr zur Tankstelle!",
  tutorialComplete: "🏆 Super! Du beherrschst die Grundlagen. Bereit für deine erste Mission auf der Grünen Piste?",
  level_marmottesName: "Grüne Piste - Les Marmottes",
  level_marmottesTask: "Präpariere die Anfängerpiste",
  level_chamoisName: "Blaue Piste - Le Chamois",
  level_chamoisTask: "Präpariere effizient vor der Öffnung",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Bereite die Freestyle-Module vor",
  level_aigleName: "Rote Piste - L'Aigle",
  level_aigleTask: "Steiles Terrain, Kraftstoff managen",
  level_glacierName: "Rote Piste - Le Glacier",
  level_glacierTask: "Lerne die Winde am Steilhang zu benutzen",
  level_tubeName: "Halfpipe - Le Tube",
  level_tubeTask: "Halfpipe für den Wettkampf vorbereiten",
  level_verticaleName: "Schwarze Piste - La Verticale",
  level_verticaleTask: "Nachteinsatz mit Winde",
  level_colDangereuxName: "Lawinenzone - Col Dangereux",
  level_colDangereuxTask: "Hochrisikogebiet vorbereiten",
  level_tempeteName: "Sturm - Bergung",
  level_tempeteTask: "Pisten nach dem Sturm räumen",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS Finale",
  level_coupeDesAiguillesTask: "Alle Pisten für den Wettkampf vorbereiten",
  
  // Hazards
  cliffFall: "⚠️ ACHTUNG! Du bist in die Schlucht gestürzt! Mission gescheitert.",
  fuelEmpty: "⛽ LEER! Kein Tropfen Diesel mehr...",
  // UNUSED avalancheZone: "LAWINENZONE",
  riskLevelHigh: "HOCH",
  avalancheWarning: "⚠️ GEFAHR! Instabile Schneedecke! Verlasse die Zone!",
  avalancheTrigger: "🏔️💨 LAWINE AUSGELÖST! Keine Flucht möglich!",
  steepWarning: "⚠️ STEILER HANG! Benutze die Winde ({winchKey}) oder du rutschst ab!",
  steepWarningNoWinch: "⚠️ STEILER HANG! Langsamer fahren und die Zufahrtswege nutzen!",
  tumble: "🔄 ÜBERSCHLAG! Der Pistenbully ist umgekippt!",
  
  // Dialogues
  jeanPierreIntro: "Gut gemacht im Tutorial, Kleiner. Jetzt wird's ernst — die Grüne, mit Timer und Kraftstoff.",
  level_marmottesMid: "Siehst du das Leuchten auf den Gipfeln? Das erste Licht. Das Beste an diesem Job — nur du, die Maschine und der Berg, der erwacht.",
  level_chamoisIntro: "Hey, ich bin Émilie — JP schickt dich auf die Blaue. Zeig, dass du mehr kannst als nur grüne Pisten zu bügeln.",
  level_airZoneIntro: "Der Snowpark ist MEIN Revier — wir bauen denen was Krasses auf! Jedes Modul muss perfekt sitzen, die Rider zählen auf uns.",
  level_aigleIntro: "L'Aigle ist ernst. Achte auf den Kraftstoff. Die Ziehwege führen zurück nach oben — achte auf die gelb-schwarz gestreiften Stangen.",
  level_glacierIntro: "Hey, ich bin Thierry — Sicherheitsbeauftragter. Le Glacier ist steil. Ich hab jeden Anker geprüft. Drücke {winchKey} neben einem Pfosten, um die Winde einzuhaken — und bitte, lass nicht los.",
  level_glacierIntroTouch: "Hey, ich bin Thierry — Sicherheitsbeauftragter. Le Glacier ist steil. Ich hab jeden Anker geprüft. Tippe auf den Winden-Button neben einem Pfosten — und bitte, lass nicht los.",
  level_tubeIntro: "Morgen ist Contest am Tube! Saubere Wände, scharfe Kante, keine Buckel.",
  level_verticaleIntro: "Nachteinsatz auf La Verticale: steiler Hang, gefährliche Ränder. Winde ist Pflicht — nutze die 3 Verankerungen und bleib in der Spur.",
  level_colDangereuxIntro: "Hohes Lawinenrisiko am Col — wir arbeiten nach Lawinensicherheitsprotokoll aktiv. Bleib aus den belasteten Zonen und halte die Grenzen ein.",
  level_tempeteIntro: "Der Sturm ist vorbei. Nimm einen Vin chaud, das wird lang!",
  level_coupeDesAiguillesIntro: "Das ist die große Nacht. Die FIS inspiziert morgen. Jede Piste muss perfekt sein — zeig mir, was du gelernt hast.",
  marieWelcome: "Komm dich aufwärmen bei Marie. Eine leckere Tartiflette!",
  marieIntro: "Hallo! Ich bin Marie, ich betreibe das Restaurant oben an der Piste. Komm vorbei, wann du willst — ein heißes Essen wirkt Wunder!",
  
  // Changelog
  changelog_20260219_date: "19. Februar 2026",
  changelog_20260219: "🎬 Prolog für neue Spieler\n📖 Vereinfachtes Tutorial\n🌦️ Zufälliges Menüwetter\n🔗 Tagesabfahrten teilbar\n🎥 Filmischer Abspann",
  changelog_20260222_date: "22. Februar 2026",
  changelog_20260222: "🚩 Slalomtor-Balancing\n💬 Feedback-Button",
  changelog_20260223_date: "23. Februar 2026",
  changelog_20260223: "📲 Jetzt auf deinem Gerät installieren und offline spielen",
  changelog_20260220_date: "20. Februar 2026",
  changelog_20260220: "🗺️ Pistenplan\n🎿 Skisport-Terminologie",
  changelog_20260217_date: "17. Februar 2026",
  changelog_20260217: "🏔️ Sieben Pistenformen\n🎯 Pistengenerierung-Vielfalt\n⚡ Flüssigere Abfahrt",
  changelog_20260216_date: "16. Februar 2026",
  changelog_20260216: "🎲 Pisten des Tages",
  changelog_20260215_date: "15. Februar 2026",
  changelog_20260215: "⚡ Nacht-Rendering überarbeitet\n📱 Ski-Modus Touchbuttons\n⌨️ Tastaturlayout-Erkennung",
  changelog_20260214_date: "14. Februar 2026",
  changelog_20260214: "🎪 Tricks & Kombos\n🏂 Hocke & Halfpipe-Physik\n👁️ Besserer Pistenkontrast\n📱 Auto-Präparierung an der Winde (Touch)\n♿ Kontrastmodus",
  changelog_20260213_date: "13. Februar 2026",
  changelog_20260213: "🚩 Slalomtore\n🏔️ Skisprünge\n⚡ Verbesserte Leistung\n🎹 Nocturne-Klaviermusik\n🔊 Motorlautstärke einstellbar",
  changelog_20260212_date: "12. Februar 2026",
  changelog_20260212: "📋 Pistenplan\n🔗 Brechbares Windenseil\n🕹️ Controller-Diagnose\n🍽️ Maries Küche\n❄️ Kälteeinwirkung",
  changelog_20260211_date: "11. Februar 2026",
changelog_20260211: "⛷️ Skiabfahrt nach der Präparierung\n🎯 Präparierqualität\n🏔️ Farblich markierte Steilzonen\n🏗️ Terrain-Park und Tricks",
  changelog_20260210_date: "10. Februar 2026",
  changelog_20260210: "🎵 Musik und Soundeffekte\n🔈 Lautstärkeeinstellungen\n⏱️ Automatisch kalibrierte Pistenzeiten\n⏭️ Tutorial überspringen\n🏔️ Lawinenzonen-Redesign",
  changelog_20260209_date: "9. Februar 2026",
  changelog_20260209: "🏔️ Alpine Sieg-/Niederlagenbilder\n❄️ Schneeakkumulation bei Sturm\n🏆 Fehlerlos-Bonus\n🔊 Wetter- und Tiergeräusche",
  changelog_20260208_date: "8. Februar 2026",
  changelog_20260208: "📊 Neues Dashboard\n🏔️ Le Glacier und Coupe des Aiguilles\n🦅 Alpine Tierwelt\n🎨 Charakterporträts\n🎮 Tastatur- & Gamepad-Navigation",
  changelog_20260207_date: "7. Februar 2026",
  changelog_20260207: "🎨 Retro-UI\n🎯 Bonusziele\n🕹️ Gamepad-Tastenbelegung\n🎮 Gamepad-Navigation",
  changelog_20260206_date: "6. Februar 2026",
  changelog_20260206: "🛤️ Befahrbare Pistenraupenspuren\n🕹️ Virtueller Joystick\n🌍 5 vollständige Sprachen",
  changelog_20260205_date: "5. Februar 2026",
  changelog_20260205: "🏔️ Felsige Klippen\n🌙 Nachtscheinwerfer\n🔗 Windenmechanik\n⌨️ Tastaturnavigation",
  changelog_20260204_date: "4. Februar 2026",
  changelog_20260204: "🎮 Gamepad-Unterstützung\n📱 Touch-Steuerung\n💪 Ausdauer\n💾 Speicherung\n♿ Barrierefreiheit",
  changelog_20260203_date: "3. Februar 2026",
  changelog_20260203: "🚜 Start: 9 Pisten, Skischule\n❄️ Präparieren, Kraftstoff, Lawinen\n🏆 Credits und Fortschritt",

  // Taunts - Cliff
  tauntCliff1: "9 Tonnen in der Schlucht. Die Versicherung wird begeistert sein.",
  tauntCliff2: "Jean-Pierre sagte: 'Nicht zu nah am Rand!' Erinnerst du dich?",
  tauntCliff3: "Die Bergwacht kommt mit Seilen. Wieder.",
  tauntCliff4: "Marie storniert deine Raclette-Reservierung für heute Abend.",
  tauntCliff5: "Thierry rechnet bereits die Reparaturkosten...",
  // Taunts - Fuel
  tauntFuel1: "Die Anzeige war 10 Minuten lang auf Rot. Was hast du angeschaut?",
  tauntFuel2: "Émilie hatte 'TANKEN' in Großbuchstaben geschrieben.",
  tauntFuel3: "Selbst Diesel hat Grenzen. Du offenbar auch.",
  tauntFuel4: "Jean-Pierre seufzt. Er schickt Thierry mit einem Kanister.",
  tauntFuel5: "Die Sonne geht auf. Die Piste ist nicht präpariert. Die Skifahrer kommen.",
  // Taunts - Time
  tauntTime1: "Erster Sessellift in 3... 2... 1... Verpasst.",
  tauntTime2: "Skifahrer entdecken deine Piste. Buckelig. Vereist. Toll.",
  tauntTime3: "Jean-Pierre schaut auf seine Uhr, dann auf dich, dann auf seine Uhr.",
  tauntTime4: "Die FIS fragt, warum der Slalom im Sulz stattfindet.",
  tauntTime5: "Du hörst Skilehrer den Gästen erklären, dass es 'nicht ihre Schuld' ist.",
  // Taunts - Tumble
  tauntTumble1: "Die Winde ist nicht zur Dekoration da.",
  tauntTumble2: "Thierry starrt auf den Schaden. Sagt nichts. Das ist schlimmer.",
  tauntTumble3: "Jean-Pierre hat dir gezeigt, wie man ankert. Hast du geschlafen?",
  tauntTumble4: "Ein PistenBully kostet 400.000€. Naja, kostete.",
  tauntTumble5: "Der Hang schien machbar? Die Raupe war anderer Meinung.",
  featureDestroyedKicker: 'Du bist über ein Park-Element gefahren! Der Kicker ist zerstört.',
  featureDestroyedRail: 'Du bist über ein Park-Element gefahren! Die Rail ist zerstört.',
  tauntFeature1: 'Drei Stunden Bauzeit für das Element. Drei Sekunden zum Plattmachen.',
  tauntFeature2: 'Émilie wird ein Wörtchen mit dir über dieses Park-Element reden.',
  tauntFeature3: 'Das Park-Team hat gerade zugesehen, wie du ihr Meisterwerk zerstört hast.',
  tauntFeature4: 'Die Module sind für Skifahrer, nicht für Pistenraupen. Drum herum fahren!',
  tauntFeature5: 'Ein Element weniger für den Wettkampf morgen.',
  bonusPipeMastery: 'Halfpipe-Beherrschung',
  // Taunts - Avalanche
  tauntAvalanche1: "Der Berg verzeiht selten. Er hat nicht verziehen.",
  tauntAvalanche2: "Météo France sagte Risikostufe 4. Hast du gelesen?",
  tauntAvalanche3: "Die Bergwacht findet die Raupe im Frühling. Vielleicht.",
  tauntAvalanche4: "Marie hört den Funkalarm. Sie weiß schon, dass du es warst.",
  tauntAvalanche5: "Die Bergwacht hatte den Sektor gesichert. Du hast ihn entsichert.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klassischer Abflug. Ausrüstung überall, Würde nirgends.",
  tauntSkiWipeout2: "Der Abhang hat sich nicht für deine Skitechnik interessiert.",
  tauntSkiWipeout3: "Die Bergwacht lacht schon. Die haben alles gesehen.",
  tauntSkiWipeout4: "Das passiert, wenn man seine eigene Piste fährt.",
  tauntSkiWipeout5: "Selbst die Steinböcke haben bei der Landung zusammengezuckt.",
  // Key names
  key_space: "LEER",
  key_shift: "UMSCHALT",
  key_ctrl: "STRG",
  key_alt: "ALT",
  key_enter: "EINGABE",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "ENTF",
  dailyRuns: "Pisten des Tages",
  dailyRuns_dailyShift: "Tagesschicht",
  dailyRuns_randomRun: "Zufälliger Einsatz",
  dailyRuns_rank: "Rang",
  dailyRuns_seed: "Code",
  // UNUSED   dailyRuns_start: "Auftrag starten",
  dailyRuns_locked: "Alle Pisten abschließen zum Freischalten",
  dailyRuns_lockedShared: "Schließe alle Pisten ab, um die Tagesläufe freizuschalten und diese geteilte Piste zu spielen",
  // UNUSED   dailyRun_levelName: "Auftrag",
  dailyRun_levelTask: "Piste auf Zielabdeckung präparieren",
  dailyRuns_briefing: "Briefing",
  dailyRuns_target: "Ziel",
  dailyRuns_timeLimit: "Zeit",
  dailyRuns_weather_clear: "Klarer Himmel",
  dailyRuns_weather_light_snow: "Leichter Schneefall",
  dailyRuns_weather_storm: "Sturmbedingungen",
  dailyRuns_night: "Nachtschicht",
  dailyRuns_day: "Tagschicht",
  rank_green: "Grün",
  rank_blue: "Blau",
  rank_red: "Rot",
  rank_black: "Schwarz",
  rank_park: "Park",
  share: "Teilen",
  copied: "Link kopiert!",
  playSharedSeed: "Geteilter Lauf",
  dailyRunBriefingJP: "Die Piste muss fertig sein, bevor die Lifte öffnen. Los geht's.",
  dailyRunBriefingThierry: "Pass auf da oben — steile Abschnitte und instabiler Schnee. Bleib wachsam.",
  dailyRunBriefingMarie: "Heute Nacht wird's bitterkalt. Komm ins Restaurant, wenn du dich aufwärmen musst.",
  dailyRunBriefingEmilie: "Noch eine Piste. Versuch mal, meine Zeit zu schlagen!"
};

export default de;
